import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CustomDropdown } from '../dropdown';
import ModalUI from 'components/modal/modalUI';
import { PATHS, PATH_NAMES } from '../../utils/constants';
import { hasManageOrgPermissions, hasExportPermissions } from '../../helpers/permissions';

function SettingsDropdown({ username, canManage, canExport, organizationName }) {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <CustomDropdown
      render={({ isOpen, openDropdown, closeDropdown }) => {
        const body = (
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={PATHS[PATH_NAMES.platform_settings]}>Platform Settings</Link>
            { canExport && <Link className="dropdown-item" to={PATHS[PATH_NAMES.reports]}>Reports</Link> }
            { canExport && <Link className="dropdown-item" to={PATHS[PATH_NAMES.bulk_exports]}>Bulk Exports</Link>}
            <Link className="dropdown-item" to={PATHS[PATH_NAMES.manage_account]}>Manage Account</Link>
            {canManage && <Link className="dropdown-item" to={PATHS[PATH_NAMES.manage_organization]}>Manage {organizationName}</Link>}
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                closeDropdown();
                setSupportOpen(true);
              }}
            >
              Support
            </button>
            <a className="dropdown-item" href="/logout/">Logout</a>
          </div>
        );
        return (
          <>
            {/* Mount ModalUI only when open so body scroll lock in modalUI didMount/unmount does not run for every page load */}
            {supportOpen ? (
              <ModalUI
                open
                close={() => setSupportOpen(false)}
                className="small center"
              >
                <div>
                  <h2>Comply Support</h2>
                  <div className="message">
                    <p><strong>24/5 Telephone Support:</strong></p>
                    <p>US: +1 646-787-9370</p>
                    <p>UK: +44 (0) 203 608 8320</p>
                    <p>HK: +852 2319 4213</p>
                    <p>
                      Email:{' '}
                      <a href="mailto:Support@comply.com">Support@comply.com</a>
                    </p>
                  </div>
                </div>
              </ModalUI>
            ) : null}
            <div className="navbar-nav">
              <div
                onClick={isOpen ? closeDropdown : openDropdown}
                className={`text-button nav-link dropdown-toggle ${isOpen ? 'active' : ''}`}
                id="dropdown03"
              >
                <span className="dropdown-toggle">{username}</span>
                <i className="material-icons dropdown-toggle">{ isOpen ? 'expand_less' : 'expand_more'}</i>
              </div>
              {isOpen && body}
            </div>
          </>
        );
      }}
    />
  );
}

SettingsDropdown.propTypes = {
  username: PropTypes.string.isRequired,
  canManage: PropTypes.bool.isRequired,
  canExport: PropTypes.bool.isRequired,
  organizationName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ user, organization: { name } }) => ({
  username: user.full_name.trim() || user.email,
  canManage: hasManageOrgPermissions(user),
  canExport: hasExportPermissions(user),
  organizationName: name,
});

export default connect(mapStateToProps)(SettingsDropdown);
